import { useState, useLayoutEffect, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

interface FooterProps {
  style?: string;
}

function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}

const FooterText = (props: FooterProps) => {
  const navigate = useNavigate();

  /* const [width, height] = useWindowSize();

  const [marginTop, setMarginTop] = useState(0);
  const [elementHeight, setElementHight] = useState(0);

  const [scrollHeightP, setScrollHeightP] = useState(0);
  const [scrollHeightM, setScrollHeightM] = useState(0);

  useEffect(() => {
    let profileHeight = document.getElementById('sidebar-profile');
    let menuHeight = document.getElementById('sidebar-menu');
    if(profileHeight != null && menuHeight != null){
        setScrollHeightP(profileHeight.clientHeight);
        setScrollHeightM(menuHeight.clientHeight);
        setMarginTop(height - (menuHeight.clientHeight+profileHeight.clientHeight+220))
        setElementHight(scrollHeightP+scrollHeightM+220);
    }else{
        setElementHight(600)
        setMarginTop(height - (600));
    }

  }, [height]) */

  return (<>
    {/*<div style={(height > 645) ? {marginTop: height - 645}: {}} className={props.style ? props.style: 'issuer-footer'} >*/}
    <div className={props.style ? props.style: 'issuer-footer'} >
      <div id="footer" className="visual-footer">
        <p>
          © {new Date().getFullYear()} MyNextID | All rights reserved |
          <span
            className="clickable"
            onClick={() => {
              navigate("/terms");
            }}
          >
            {" "}
            Terms of use{" "}
          </span>
          |
          <span
            className="clickable"
            onClick={() => {
              navigate("/privacy");
            }}
          >
            {" "}
            Privacy policy
          </span>
        </p>
      </div>
    </div>
  </>);
};

export default FooterText;
